export default __webpack_public_path__ + "static/media/loading.724456f1.gif";